module.exports = __webpack_public_path__ + "6b3973ffe02bb6a8be0f8453506ec032.woff2";